import { resolve } from 'styled-jsx/css';
import { LARGE, MEDIUM, SMALL, X_SMALL } from 'lib/DeviceScreen';
import { SHOPPING_LINKS, LEADERBOARD, MEDIUM_RECTANGLE } from 'lib/GoogleAds/Sizes';
import Ad from '.';
import ProximityAd from './ProximityAd';

/* istanbul ignore next */
const shoppingLinksCSS = resolve`
  .ad {
    justify-content: left;
  }
`;

export const ADS_DICTIONARY: Record<string, any> = {
  bpov: (
    <Ad
      adConfig={{
        targeting: {
          ntve: 'bpov',
          slot: 'bpov',
        },
        dimensions: ['fluid'],
      }}
    />
  ),
  'dt-shopping-link': (
    <>
      <Ad
        adConfig={{
          targeting: {
            slot: 'dt-shopping-link',
          },
          dimensions: [[400, 40]],
          screenSizes: [LARGE],
        }}
        placeholderSize={SHOPPING_LINKS}
        className={shoppingLinksCSS.className}
      />
      {shoppingLinksCSS.styles}
    </>
  ),
  'dt-wide-breaker': (
    <ProximityAd
      adConfig={{
        targeting: {
          slot: 'dt-wide-breaker',
        },
        dimensions: [[728, 90]],
        screenSizes: [LARGE],
      }}
      placeholderSize={LEADERBOARD}
    />
  ),
  'm-box-1': (
    <ProximityAd
      adConfig={{
        targeting: {
          slot: 'm-box-1',
        },
        dimensions: [
          [320, 50],
          [300, 250],
          [300, 300],
        ],
        screenSizes: [MEDIUM, SMALL, X_SMALL],
      }}
      placeholderSize={MEDIUM_RECTANGLE}
    />
  ),
  'm-box-2': (
    <ProximityAd
      adConfig={{
        targeting: {
          slot: 'm-box-2',
        },
        dimensions: [
          [320, 50],
          [300, 250],
          [300, 300],
        ],
        screenSizes: [MEDIUM, SMALL, X_SMALL],
      }}
      placeholderSize={MEDIUM_RECTANGLE}
    />
  ),
  'm-box-breaker': (
    <ProximityAd
      adConfig={{
        targeting: {
          slot: 'm-box-breaker',
        },
        dimensions: [
          [320, 50],
          [300, 250],
          [300, 300],
        ],
        screenSizes: [MEDIUM, SMALL, X_SMALL],
      }}
      placeholderSize={MEDIUM_RECTANGLE}
    />
  ),
};

interface ContentAdProps {
  adType: string;
}

export default function ContentAd({ adType }: ContentAdProps): JSX.Element {
  const ad = ADS_DICTIONARY[adType] || null;

  if (!ad) {
    console.error(
      `Ad type ${adType} is not a valid in-content ad type, valid types are ${Object.keys(
        ADS_DICTIONARY
      )}`
    );
  }

  return ad;
}
